module.exports = __webpack_public_path__ + "flyer_background_floral_frame_white_085-04a847afab4e34ba3f1a055f8de6c409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_floral_frame_white_085.jpg
// module id = 1645
// module chunks = 1